import { Injectable } from '@angular/core';
import { GlobalDataService } from '../../services/global-data.service';
import { INavDataExtended } from '../../models/depart-region-depot.model';
import { ReplaySubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NavItemsService {
  _navItems: INavDataExtended[] = [];
  private navDataReceivedSubject = new ReplaySubject<boolean>();
  navDataReceivedObservable = this.navDataReceivedSubject.asObservable();
  constructor(private global: GlobalDataService) {
    this.global
      .getDepartmentData()
      .subscribe((navItems: INavDataExtended[]) => {
        this._navItems = navItems;
        this.navDataReceivedSubject.next(true);
      });
  }

  findDepartmentName(departmentId: number): string | undefined {
    // Iterate through the data to find the department by id
    const department = this._navItems.find(
      (item) => item.type === 'DEPT' && item.id === departmentId
    );

    // If department is found, return the name, else return undefined
    return department ? department.name : undefined;
  }

  findDepartmentAverageScoreRequired (departmentId: number): number | undefined {
    // Iterate through the data to find the department by id
    const department = this._navItems.find(
      (item) => item.type === 'DEPT' && item.id === departmentId
    );

    // If department is found, return the name, else return undefined
    return department ? department.expected_avg_utilization_score : undefined;
  }

  findRegionName(departmentId: number, regionId: number): string | undefined {
    // Find the department first
    const department = this._navItems.find(
      (item) => item.type === 'DEPT' && item.id === departmentId
    );

    // If the department is found, search within its children for the region
    if (department && department.children) {
      const region = department.children.find(
        (child: any) => child.type === 'REGION' && child.id === regionId
      );
      return region ? region.name : undefined;
    }

    // Return undefined if no region is found
    return undefined;
  }



  findDepotName(
    departmentId: number,
    regionId: number,
    depotId: number
  ): string | undefined {
    // Find the department first
    const department = this._navItems.find(
      (item) => item.type === 'DEPT' && item.id === departmentId
    );

    // If the department is found, search within its children for the region
    if (department && department.children) {
      const region = department.children.find(
        (child: any) => child.type === 'REGION' && child.id === regionId
      );

      // If the region is found, search for the depot within its children
      if (region && region.children) {
        const depot = region.children.find(
          (child: any) => child.type === 'DEPOT' && child.id === depotId
        );
        return depot ? depot.name : undefined;
      }
    }

    // Return undefined if no depot is found
    return undefined;
  }

  findRegionByDepotId(
    departmentId: number,
    depotId: number
  ): INavDataExtended | undefined {
    // Find the department first
    const department = this._navItems.find(
      (item) => item.type === 'DEPT' && item.id === departmentId
    );
    let foundRegion = null;
    // If the department is found, search within its children for the region
    if (department && department.children) {
      // const region = department.children.find(
      //   (child: any) => child.type === 'REGION' && child.id === regionId
      // );

      for (let index = 0; index < department?.children.length; index++) {
        const region = department?.children[index];
        if (region && region.children) {
          const depot = region.children.find(
            (child: any) => child.type === 'DEPOT' && child.id === depotId
          );

          if (depot) {
            return region as INavDataExtended;
          }

        }
       
      }

    }

    // Return undefined if no depot is found
    return undefined;
  }

  

}
